import React from 'react'
import SvgIcon from 'rambler-ui/icons/SvgIcon'

export default function AfishaLogo ({width, height}) {
  return (
    <SvgIcon
      color='currentColor'
      style={{
        width: width,
        height: height
      }}
      viewBox='0 0 130 50'>
      <path
        fill='#231F20'
        fillRule='nonzero'
        d='M33.373 21.38c0-1.398-1.136-1.99-2.412-1.99H20.595l-.001 1.968h7.878c.608 0 1.104.232 1.104.953l.003.366h-7.506c-1.31 0-2.073.968-2.073 2.033v2.357c0 .953.714 2.096 2.073 2.096h11.293l.007-7.784zm-9.588 4.276c0-.522.282-.969 1.097-.969h4.697v2.357h-4.675c-.92 0-1.12-.573-1.12-.873v-.515zM110 21.379l-.007 7.784H98.7c-1.359 0-2.074-1.143-2.074-2.096V24.71c0-1.065.763-2.033 2.074-2.033h7.506l-.004-.366c0-.72-.495-.953-1.103-.953h-7.878V19.39h10.367c1.275 0 2.412.591 2.412 1.988zm-9.587 4.277v.515c0 .3.197.873 1.118.873h4.675v-2.357h-4.697c-.815 0-1.096.447-1.096.969zM67.91 24.218c0-.51.027-1.49.027-1.49l-5.672 6.436h-3.941v-9.748h3.94v5.227c0 .631-.017 1.14-.017 1.14l5.663-6.367h3.945v9.745l-3.945.003v-4.946zm26.925-4.802v9.748H73.804v-9.748h3.96v7.628h4.597v-7.628h3.943v7.628h4.6v-7.628h3.931zm-40.722-.047c1.274 0 2.413.592 2.413 1.99v5.717c0 1.4-1.139 2.13-2.413 2.13h-6.269v5.37h-3.937v-5.37h-6.268c-1.276 0-2.413-.73-2.413-2.13V21.36c0-1.398 1.137-1.99 2.413-1.99h6.268V14h3.937v5.369h6.269zm-1.384 6.684v-3.67c0-.723-.496-1.045-1.106-1.045H47.84V27.1h3.782c.61 0 1.106-.323 1.106-1.046zM43.91 27.1v-5.76h-3.782c-.61 0-1.105.321-1.105 1.044v3.67c0 .723.495 1.046 1.105 1.046h3.782zM0 0v50V0zm130 0v50V0z'
      />
    </SvgIcon>
  )
}
